import OfficeAppliancesTypeTable from "./OfficeAppliancesTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const Type = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_officeappliances_type_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) && (
        <OfficeAppliancesTypeTable />
      )}
    </>
  );
};

export default Type;
